import {ValueObject} from '@s-ui/domain'

export class BrandModelInfoValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.name
   * @param {String} params.description
   * @param {String} params.imageUrl
   * */
}
